export default {
  bad_connection: 'oops, something wrong. Please check your network connection and then try again',
  send: 'Send',
  select_hotel: 'Please select the hotel you are staying',
  select_language: 'Please select your language.',
  start_chatting: 'Start Chatting',
  languages: 'Languages',
  menu: 'Menu',
  close: 'Close',
  back: 'Back',
  next: 'Next',
  message: 'Please ask a question',
  search: 'Search',
  select: 'Select',
  sign_in: 'Sign in',
  sign_out: 'Sign out',
  sign_up: 'Sign up',
  smoking: 'Smoking',
  no_smoking: 'Non-Smoking',
  adults: 'Adult',
  xAdults: 'Adult | Adult | Adults',
  children: 'Child',
  ageOfChild: 'Age of child',
  seeAll: 'See all',
  email: 'Email',
  email_confirmation: 'Email (for confirmation)',
  phone_number: 'Phone Number',
  icc: 'ICC',
  month: 'Month',
  year: 'Year',
  including_taxes: 'including tax',
  excluding_taxes: 'excluding tax',
  show_more: 'Show more',
  show_less: 'Show less',
  file_upload: {
    unsupported_file_type: 'Sorry, we do not support files of type {file_type}',
    file_size_exceeded: 'File exceeds the size limit of 10mb',
    file_upload_failed: 'File upload failed',
    max_files_upload_simultaneously: 'A maximum of 5 files can be uploaded simultaneously'
  },
  base: {
    back_to_list: 'back to list',
    pay: 'Pay',
    cancel: 'Cancel',
    delete: 'Delete',
    yes: 'Yes',
    no: 'No',
    book: 'Book',
    direct_price: 'Direct Price',
    membership_rate: 'Membership Rate',
    regular_rate: 'Regular Rate',
    expand_for_price: 'Expand to compare',
    confirmSelection: 'Confirm selections',
    neverAskAgain: "Don't ask again",
    accept: 'Accept',
    do_not_accept: 'Do not accept',
    password: 'Password',
    email: 'Email',
    save: 'Save',
    confirm_password: 'Confirm password',
    error02: 'An error occurred during processing. Please try again later.',
    errorCode: {
      3001: 'A timeout error has occurred. The payment has not been processed.',
      3002: 'The payment process has failed. ',
      3003: 'This card was not available.',
      3004: 'Please confirm the card number.',
      3005: 'Please make sure your expiration date is correct.',
      3006: '3D Secure authentication failed.',
      3007: 'The credit card is not accepted or the card number is incorrect.',
      3008: '3D Secure authentication has been cancelled.',
      3009: '3D Secure authentication has been suspended due to multiple requests.',
      3011: 'A timeout error has occurred. The payment has not been processed.',
      3203: 'An error occurred during processing. Please try again later.',
      3204: 'The payment process has failed, Please use another card, or retry later.',
      3205: 'This card was not available.'
    }
  },
  triplaPayIssues: {
    INVALID_PARAMETER_SYNTAX: 'Please review information that you have entered.',
    INVALID_EXPIRATION_YEAR: 'Please make sure your expiration date is correct.',
    Invalid_card_number: 'Please confirm the card number.',
    Others: 'Please review information that you have entered.'
  },
  validation: {
    is_required: '{field} is required',
    correct_email: 'Please enter a correct email address',
    invalid_integer: 'Please input an integer'
  },
  chat_body: {
    deleted_message: 'You deleted this message',
    op_deleted_msg: 'Operator deleted this message',
    delete_message: 'Delete Message',
    delete_message_desc: 'Are you sure you want to delete this message? This cannot be undone'
  },
  user_top: {
    information:
      'If you want to continue chatting with us on the other devices, please sign up. You can retrieve you messages on any devices when you sign in.',
    terms_and_condition: {
      before: 'By signing up, I agree to ',
      link: 'the Terms and Conditions',
      and: 'and',
      privacy_policy: 'Privacy Policy',
      after: '.'
    },
    sign_in_with_facebook: 'Sign-in with Facebook',
    sign_out_with_facebook: 'Sign out of Facebook on this device',
    sign_in_with_line: 'Sign-in with LINE',
    sign_in_with_weibo: 'Sign-in with Weibo',
    create_account: 'Create Account',
    or: 'or',
    already_have_an_account: 'Already have an account?',
    sign_in_with_email: 'Sign-in with Email',
    forgot_password: 'Forgot password?'
  },
  new_user: {
    information: 'Please enter your name and email address and hit Sign-up.',
    information2: 'You will receive verification from chatbot@tripla.jp',
    first_name: 'First name',
    last_name: 'Last name',
    name_placeholder: 'Your name',
    email_placeholder: 'Email address',
    submit: 'Sign-up',
    email_sent:
      'A verification link has been sent to your email address. Please click on the link that has just been sent and {sign in}',
    error_message: {
      problem:
        'There was a problem creating your account. Please check your email address and try again.',
      email: 'Email is invalid or already taken'
    }
  },
  new_session: {
    information: 'Please enter your email address and password and hit Sign-in',
    email_placeholder: 'Email address',
    password_placeholder: 'Password',
    submit: 'Log In/Membership Registration',
    error_message: {
      email: 'Sorry but your email or password may be incorrect',
      known_user_different: 'The known user is different'
    }
  },
  destroy_session: {
    information:
      'Do you want to sign-out? You need to sign back in if you want to display the existing message.',
    submit: 'Sign-out'
  },
  forgotten_password: {
    information:
      'Please enter your email address. We will send confirmation to your email account.',
    email_placeholder: 'Email address',
    submit: 'Send',
    error: 'Unable to reset password'
  },
  forgotten_password_confirmation: {
    information:
      'You will receive an email with instructions on how to reset your password in a few minutes.'
  },
  reset_password: {
    title: 'Change Password',
    password_title: 'Password',
    password_hint: 'at least 8 characters',
    password_confirmation_title: 'Password (confirm)',
    submit: 'Change password'
  },
  set_reset_password: {
    title: 'Change Password',
    information: 'Your password has been reset.',
    information2: 'Please go back to where you reset password and sign-in again.'
  },
  menu_items: {
    1: 'Check room availability',
    2: 'Room reservation',
    3: 'Confirm room reservation'
  },
  modal: {
    back_to_chat: 'Back to chat'
  },
  gmoPaypalOptions: {
    visa: 'VISA',
    master: 'Mastercard',
    mastercard: 'Mastercard',
    amex: 'American Express',
    jcb: 'JCB',
    diners: 'Diners Club'
  },
  credit_card: {
    error: {
      cvv: 'Please make sure your CVV is correct',
      expiration: 'Please make sure your expiration date is correct',
      name: "Please make sure the card holder's name is correct",
      number: 'Please use a valid credit card number',
      unknown:
        'THere was a problem processing your request, please make sure the information you provided is correct',
      reservation_month:
        'Please make sure that credit card expiry date should have at least one month left after the reservation date.'
    },
    accept: 'We accept:',
    cvv: 'CVV',
    expiration: 'Expiration Date',
    intro: 'Please enter the required information for the card you would like to use',
    name: "Card Holder's Name",
    number: 'Card Number',
    save: 'Save This Card',
    submit: 'Add card',
    title: 'Add New Credit Card',
    security_code: 'Security Code',
    card_holder_confirm: 'Please confirm the name of the card holder',
    card_holder_format_confirm: 'Please enter your name in half-width Roman characters.',
    expiration_confirm: 'Please confirm the expiration date',
    card_cvv_confirm: 'Please confirm the security code',
    card_number_confirm: 'Please confirm the card number',
    card_brand: 'Card Type',
    select_card_brand: 'Select card type'
  },
  payment: {
    total: 'Total'
  },
  currencies: {
    JPY: 'JPY'
  },
  chat_channels: {
    title: 'Please choose a channel',
    facebook: 'Messenger',
    web: 'Web',
    line: 'LINE',
    whats_app: 'WhatsApp'
  },
  rev_requests: {
    title: 'Requests',
    request: 'Request',
    status: 'Status',
    no_data: 'You currently have no request',
    payment: 'Payment',
    customer: 'Customer',
    phone: 'Phone',
    people: 'People',
    facility_name: 'Facility name',
    requested_day: 'Requested day',
    requested_time: 'Requested time',
    confirm_cancel_msg:
      'Please confirm that you wish to cancel this request. We will send a notification to the managers and once cancellation is completed, you will receive a confirmation.',
    cancel_request: 'Cancel Request',
    edit_request: 'Edit Request',
    keep_request: 'Keep Request'
  },
  requests: {
    statuses: {
      _destroyed: 'Destroyed',
      cancel_requested: 'Cancel requested',
      cancelled: 'Cancelled',
      change_requested: 'Update requested',
      created: 'Created',
      departure_unconfirmed: 'Departure unconfirmed',
      done: 'Done',
      in_progress: 'In Progress',
      no_show: 'No show',
      stopped: 'Stopped',
      wait_listed: 'Wait listed',
      waiting_detail: 'Waiting detail'
    }
  },
  best_rate: 'BEST RATE',
  time_picker: {
    AM: 'AM',
    PM: 'PM'
  },
  details_page: {
    details: 'More Details'
  },
  date_range: {
    select: 'Select the dates for your stay',
    send: 'Click select to proceed',
    no_disabled_dates: 'You cannot include unavailable date. Please pick the correct date range'
  },
  facebook: {
    email_sent:
      'A verification link has been sent to your email address. Please click on the link to confirm and proceed',
    no_email:
      'Please provide your email address. We will send you reservation confirmation after reservation is made. ',
    signInFailed: 'Login failed, please try again',
    sign_out: 'Please click on the button below to sign out of Facebook.'
  },
  confirm_form: {
    search: 'Search Again',
    update_contact: 'Update Contact Info'
  },
  contact_form: {
    update: 'Update',
    submit: 'Submit',
    full_name: 'Full Name',
    family_name: 'Family Name',
    first_name: 'First Name',
    cc_email: 'cc email to ...',
    error: {
      full_name_error: 'Please provide full name in English',
      tel_format_error: 'Numbers, spaces, +, and () could be used as phone numbers.',
      tel_length_error: 'Please enter a phone number with more than 9 digits.',
      email_format_error: 'Please provide a valid email address (eg. name@gmail.com)',
      email_confirmation_error: 'email addresses not identical'
    }
  },
  room_not_available: "Sorry, we don't have any rooms available for the dates you selected.",
  search_again: 'Search Again',
  room_not_available_short: 'Not Available.',
  email_form: {
    note_placeholder: 'Please enter details regarding your request'
  },
  rental_car_form: {
    pickup_title: 'Pick-up shop',
    pickup_area: 'Area selection',
    pickup_shop: 'Shop selection',
    pickup_date_time: 'Pick-up date',
    return_title: 'Return shop',
    return_area: 'Area selection',
    return_shop: 'Shop selection',
    return_date_time: 'Return date',
    back: 'Back'
  },
  search_area_form: {
    select_prefecture_area: 'Please select prefecture and area',
    prefecture: 'Prefecture',
    area: 'Area'
  },
  restaurant_form: {
    breakfast: 'Breakfast',
    lunch: 'Lunch',
    dinner: 'Dinner',
    main_time: 'Main Time',
    alternative_times: 'Alternative times',
    pick_multiple: 'Please pick multiple. We suggest 3',
    any_available_time: 'Any available times'
  },
  terms_of_use: 'Terms of use',
  privacy_policy: 'Privacy Policy',
  browser_warning:
    'Your web browser is out of date. Please update it for better security, speed and experience on this site.',
  for_night: 'for {n} night | for {n} night | for {n} nights',
  chat_icon: {
    chat: 'Chat'
  },
  chat_evaluation: {
    title: 'Customer Satisfaction',
    msg: 'Please take a moment to let us know whether you are satisfied with our chatbot or not',
    not_satisfied: 'Not Satisfied',
    satisfied: 'Satisfied'
  },
  cookie_consent: {
    title: 'Manage Cookie Consent',
    necessary: 'Necessary: Chat history and login status',
    functional:
      'Functional: These cookies save your preferences like privacy policy and chatbot layout',
    performance:
      'Performance: These cookies help us count visits and user clicks to help us improve our service',
    advertising:
      'Targeting and advertising: These cookies make advertising messages more relevant to you',
    accept_all: 'Accept All',
    confirm: 'Confirm my choices',
    cookies_accepted: 'Cookies accepted'
  },
  ota_name: {
    agoda: 'Agoda',
    booking_com: 'Booking com',
    expedia: 'Expedia',
    jalan: 'Jalan',
    rakuten_travel: 'Rakuten Travel',
    rakutenTravel: 'Rakuten Travel'
  }
}
